import styled from 'styled-components';

export const TabsBar = styled.nav`
  flex: 0 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.level4};
`;
